module.exports = __webpack_public_path__ + "img/advent_birds_desktop_left.734b7fee.svg";